module.exports = __webpack_public_path__ + "static/media/jiaming_img.a3dd1a68.svg";